module.exports = __webpack_public_path__ + "img/RouteManagement.92fe9d19.svg";